import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MasterConstants } from './../../../common/constants/master-constants';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CppCoiRequestService } from '../../../services/cpp-coi-request/cpp-coi-request.service';
import { CppCoiAddProductSliderModelService } from '../cpp-coi-add-product/cpp-coi-add-product-slider-model.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { CPPFilterComponent } from './../../../modules/cpp/cpp-common-components/cpp-filter/cpp-filter.component';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp-coi-add-product',
  templateUrl: './cpp-coi-add-product.component.html',
  styleUrls: ['./cpp-coi-add-product.component.scss']
})

export class CppCoiAddProductComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(CPPFilterComponent) cppFilter: CPPFilterComponent;
  private subscription = new Array<Subscription>();

  productList: any;
  parentProductList: any;
  tabProductList: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  productAllDataSource: any;
  parentAccountDataSource: any;
  isProductNotAdded = true;
  selectedProductList = new Array();
  itemList = new Array();
  displayedColumns: string[] = ['Product Name', 'detail', 'Item Number', 'Available Units', 'Pack Size', 'Product Line'];
  private selectedTabIndex = 0;
  filterTypeList = [
    { label: 'Product Name', column: 'productName' },
    { label: 'Package Size', column: 'packageSize' },
    { label: 'Vendor', column: 'vendor' },
    { label: 'Product Line', column: 'productLine' },
    { label: 'Item Number', column: 'itemNumber' },
    { label: 'Active Ingredient', column: 'activeIngredients' },
    { label: 'GTIN', column: 'gtin' }
  ];

  constructor(
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private cppCoiAddProductSliderModelService: CppCoiAddProductSliderModelService,
    private loaderService: LoaderService,
    private cppCoiRequestService: CppCoiRequestService,
    public excelService: ExcelService) {
  }

  // ngOnInit
  ngOnInit() {
    const filters: any = {};
    filters.showFavoriteOnly = false;
    this.getAllProducts(filters);
  }

  // search in master search area
  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1;
  }

  // search in master search area
  public filterUOMFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.id.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Search the account details on shipto / Deliverto dropdown
  productSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.itemDescription.toLocaleLowerCase().indexOf(term) > -1
      || item.itemNumber.toLocaleLowerCase().indexOf(term) > -1
      || item.itemVendorName.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Reset the list for lotnumber and products dropdown
  resetItems() {
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isSelected = !item.isSelected;
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    const data = [];
    if (this.selectedProductList.length > 0) {// Addition use case implemented asked in bug 74741
      this.selectedProductList.forEach(x => {
        const duplicateData = data.find(y => y.itemNumber == x.itemNumber && y.orderUOM == x.orderUOM);
        if (duplicateData) {
          if (!duplicateData.isParent && this.selectedTabIndex === 1) {
            var index = data.indexOf(duplicateData);
            if (index !== -1) {
              data.splice(index, 1);
            }
            data.push(x);
          }
          else if (duplicateData.isParent && this.selectedTabIndex === 0) {
            var index = data.indexOf(duplicateData);
            if (index !== -1) {
              data.splice(index, 1);
            }
            data.push(x);
          }
        }
        else {
          data.push(x);
        }
      });

      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: data.length });
    }
    this.cppCoiAddProductSliderModelService.setData<CppCoiAddProductSliderModelService[]>(data);
    this.cppCoiAddProductSliderModelService.cppCoiClose();
  }

  getAllProducts(filters) {
    filters.shipToOrDeliverToAccount = this.cppCoiAddProductSliderModelService.shipToOrDeliverToAccount;
    filters.shipToAccount = this.cppCoiAddProductSliderModelService.shipToAccount;
    filters.isCustomerPickup = this.cppCoiAddProductSliderModelService.isCustomerPickup;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppCoiRequestService.getProductMaster(filters).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.tabProductList = result;
        this.loaderService.setLoaderStatus(false);

        this.productList = this.tabProductList.filter(x => x.isParent == false);
        this.productAllDataSource = new MatTableDataSource(this.productList);

        this.parentProductList = this.tabProductList.filter(x => x.isParent == true);
        this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);

        this.tabProductList.forEach(x => {
          if (this.selectedProductList.filter(y => y.itemNumber == x.itemNumber).length > 0) {
            x.IsProductSelected = true;
          }
          else {
            x.IsProductSelected = false;
          }
        });
        this.loaderService.setLoaderStatus(false);
      }
      else {
        this.toastrService.info('No records found.');
        this.productList = [];
        this.loaderService.setLoaderStatus(false);
      }
    }, (error) => {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource([]);
      this.parentAccountDataSource = new MatTableDataSource([]);
      this.toastrService.error('No records found.');
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      this.isProductNotAdded = false;
    }
    else {
      this.isProductNotAdded = true;
    }
  }
  // Clear Grid data
  clearGridData(filters) {
    this.productList = [];
    this.productAllDataSource = new MatTableDataSource(this.productList);
    this.parentProductList = [];
    this.parentAccountDataSource = new MatTableDataSource(this.parentProductList);

    if (filters) {
      this.getAllProducts(filters);
    }
  }

  filterProductGridData(filters) {
    if (filters.clearAll == false) {
      this.setAccInvProdTableHeight();
      if (!this.validateProductFilter(filters)) {
        this.toastrService.error('Value must greater than equal to 2 characters.');
        return true;
      }
      this.getAllProducts(filters);
    }
    else {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource(this.productList);
      filters.clearAll = false;

      const filter: any = {};
      filter.showFavoriteOnly = true;
      this.setAccInvProdTableHeight();
      this.getAllProducts(filter);
    }
    this.enableDisableAddProductBtn();
  }

  // Update selected prodcut list
  keepRecords(product, isProductTab) {
    product.IsProductSelected = !product.IsProductSelected;
    const itemNumber = product.itemNumber;
    const orderUOM = product.orderUOM;
    const isParent = product.isParent;
    if (product.IsProductSelected) {
      let item;

      // Select the clicked object into array
      this.itemList.push({ 'itemNumber': itemNumber, 'orderUOM': orderUOM });
      if (isProductTab) {
        item = this.productList.filter(i => i.itemNumber == itemNumber && i.orderUOM == orderUOM && i.isParent == isParent);
      } else {
        item = this.parentProductList.filter(i => i.itemNumber == itemNumber && i.orderUOM == orderUOM && i.isParent == isParent);
      }
      this.selectedProductList.push(item[0]);
    }
    else {
      let index = this.itemList.findIndex(x => x.itemNumber == itemNumber && x.orderUOM == orderUOM);
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      index = this.selectedProductList.findIndex(x => x.itemNumber == itemNumber && x.orderUOM == orderUOM);
      if (index !== -1) {
        this.selectedProductList.splice(index, 1);
      }
    }
    this.enableDisableAddProductBtn();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    if (this.selectedTabIndex === 0) {
      this.setAccInvProdTableHeight();
    } else if (this.selectedTabIndex === 1) {
      this.setcompInvProdTableHeight();
    }
  };

  // set Add product table height
  setAccInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .accInvProdTable').css('max-height', tableHeight + 'px');
  }

  setcompInvProdTableHeight() {
    const tableHeight = window.innerHeight - $('.prod-top-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.seed-return-add-prod .compInvProdTable').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccInvProdTableHeight();
    this.setcompInvProdTableHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  public export() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.productList && this.productList.length > 0) {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'Available Units': x.availableUnits,
          'Pack Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'AccountProductsReport');
    } else if (this.selectedTabIndex === 1 && this.parentProductList && this.parentProductList.length > 0) {
      const filteredList = this.parentProductList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Name': `${x.itemVendorName}/${x.itemDescription}`,
          'Item Number': x.itemNumber,
          'Available Units': x.availableUnits,
          'Pack Size': x.packageSize,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'ParentProductsReport');
    }

    this.loaderService.setLoaderStatus(false);
  }

  public isDisableExportButton(): boolean {
    let retVal = true;

    if (this.selectedTabIndex === 0 && this.productList) {
      retVal = this.productList.filter(x => x.displayMessage == null).length === 0;
    } else if (this.selectedTabIndex === 1 && this.parentProductList) {
      retVal = this.parentProductList.filter(x => x.displayMessage == null).length === 0;
    }

    return retVal;
  }

  public isShowExportButton(): boolean {
    return [0, 1].includes(this.selectedTabIndex);
  }

  public getSelectedCount() {
    const distinctThings = this.selectedProductList.filter((thing, i, arr) => arr.findIndex(x => x.itemNumber === thing.itemNumber && x.orderUOM === thing.orderUOM) === i);
    return distinctThings.length;
  }

  // to validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate MarketingBrand
    if (productFilter.itemNo != null && productFilter.itemNo.length > 0) {
      isValid = true;
    }

    // To Validate ProductName
    if (productFilter.productName !== null && productFilter.productName !== '' && productFilter.productName.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ActiveIngredient
    if (productFilter.activeIngredient !== null && productFilter.activeIngredient !== '' && productFilter.activeIngredient.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Vendor
    if (productFilter.vendor !== null && productFilter.vendor !== '' && productFilter.vendor.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Gtin
    if (productFilter.gtin !== null && productFilter.gtin !== '' && productFilter.gtin.toString().trim().length >= 2) {
      isValid = true;
    }
    // To Validate ProductLine
    if (productFilter.productLine !== null && productFilter.productLine !== '' && productFilter.productLine.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.packageSize !== null && productFilter.packageSize !== '' && productFilter.packageSize.toString().trim().length >= 2) {
      isValid = true;
    }

    if (productFilter.productName == null
      && (productFilter.itemNo == null || productFilter.itemNo.length <= 0)
      && productFilter.activeIngredient == null
      && productFilter.vendor == null
      && productFilter.gtin == null
      && productFilter.productLine == null
      && productFilter.packageSize == null) {
      isValid = false;
    }
    return isValid;
  }
}
